import React, { Component } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
// theme
import ColorModeProvider from './theme/ColorModeProvider';
// styles
import './index.css';
// components
import { StyledChart } from './components/chart';
import ScrollToTop from './components/scroll-to-top';
import './i18n';
import { AppDataProvider } from './context/AppDataProvider';
import Router from './routes';
import AlertWrapper from './components/alert';
import { AppDataContext } from './context/Context';

class App extends Component {
    constructor(props) {
        super(props);
        this.state = {
            value: true
        };
    }

    forceUpdate = () => {
        this.setState((prevState) => ({
            value: !prevState.value
        }));
    };


    render() {

        globalThis.app = this;

        return (
            <HelmetProvider>
                <BrowserRouter>
                    <ColorModeProvider>
                        <ScrollToTop />
                        <StyledChart />
                        <AppDataProvider>
                            <AppDataContext.Consumer>
                                {value => <Router context={value}/>}
                            </AppDataContext.Consumer>
                            <AlertWrapper />
                        </AppDataProvider>
                    </ColorModeProvider>
                </BrowserRouter>
            </HelmetProvider>
        );
    }
}

export default App;
